import React from "react";

const Icon = ({ url, classes, path }) => {
  return (
    <div className={classes}>
      <img
        alt="fontawesome icon"
        src={(path && path + url) || url}
        className={classes}
        style={{ height: 15 }}
      />
    </div>
  );
};
export default Icon;
